{% block sw_cms_element_jga_revocation_button_preview %}
<div class="sw-cms-el-preview-jga-revocation-button" style="text-align: center; padding: 15px;">
    <div style="display: inline-block; background: #0870e0; color: white; padding: 10px 24px; border-radius: 4px; font-size: 14px; font-weight: 600;">
        {{ $tc('jga-revocation.cms.previewLabel') }}
    </div>
</div>
{% endblock %}
